<template>
  <div>
    <h2 class="content-block">Belajar_tagbox</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="refDataGridArsip"
          :data-source="arsipListStore.dataSourceArsipList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :word-wrap-enabled="true"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="50" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            :mode="row"
          />
          <DxSorting mode="multiple" />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxColumnFixing :enabled="true" />

          <dx-column
            data-field="arsips_id"
            caption="ARSIP ID"
            data-type="number"
            :visible="true"
          />
          <dx-column
            data-field="arsip_pegawais_pegawai_ids"
            caption="Pegawai Bersangkutan"
            :visible="true"
            edit-cell-template="tagboxEditCellTemplate"
          >
          </dx-column>
          <template #tagboxEditCellTemplate>
            <DxTagBox
              :searchEnabled="true"
              :searchExpr="['display_expr']"
              :items="pegawaiSource"
              :show-selection-controls="true"
              apply-value-mode="useButtons"
              displayExpr="display_expr"
              valueExpr="id"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import { DxTagBox } from "devextreme-vue/tag-box";
import { BASE_URL } from "@/global-constants";
import StatusTemplate from "./StatusTemplate.vue";
import { useArsipListStore } from "@/stores/views/arsip-list-store";
import { useCommonStore } from "@/stores/utility/common-store";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  // DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];

/* eslint-disable */
export default {
  components: {
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    // DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusTemplate,
    DxTagBox,
  },
  setup() {
    const arsipListStore = useArsipListStore();
    const commonStore = useCommonStore();

    return {
      arsipListStore,
      commonStore,
    };
  },
  data() {
    const vm = this;
    return {
      pegawaiSource: [
        { id: 243, nama: "243" },
        { id: 114, nama: "114" },
        { id: 99, nama: "99" },
        { id: 403, nama: "403" },
      ],
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      filterValue: [],
      options: options,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
    };
  },

  async mounted() {},

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },
    handleClickDocument(e) {
      if (e.data.file_path !== null)
        window.open(
          this.serverUrl + e.data.file_path,
          "_blank",
          "location=yes"
        );
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar KGB.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
